import { routes as rootRoutes } from './routes';
import { RouteProps } from './types';

export const getNavRoutes = (routes?: RouteProps[]): RouteProps[] =>
  (routes || rootRoutes).filter(({ meta }) => {
    const { title, navLink } = meta || {};
    return title && navLink !== false;
  });
